import {
  MEMBERSHIP_ROLE_LIST_ROLE_ROW_UPDATE,
  SET_DELIVERY_CHARGE_LIST_DATA,
  SET_MASTER_DATA_FORM_DATA,
  SET_MASTER_DATA_LIST_DATA,
  SET_MASTER_DATA_OPTIONS,
  SET_MASTER_FORM_DATA,
  SET_MASTER_LIST_DATA,
  SET_MASTER_OPTIONS,
  SET_MEMBERSHIP_ROLE_LIST_DATA,
  SET_MODULE_LIST_DATA,
  SET_MODULE_LIST_DATA_WITH_CHILDS,
  SET_MODULE_OPTIONS,
  SET_OPERATIONS_DATA,
  SET_REPORT_CONFIGS_LIST_DATA,
  SET_ROLE_GROUP_LIST,
  SET_ROLE_GROUP_LIST_WITH_CHILDS,
  SET_ROLES_LIST,
  SET_SETTINGS_ENROLLMENT_TYPE,
  SET_STAFF_LIST_DATA,
  SET_STATE_LIST_DATA,
  SET_STOCK_LOCATION_LIST_DATA,
  SET_TAX_LIST_DATA,
  SET_USER_COUNTRY_LOCATIONS_DATA,
  SET_ZONE_LIST_DATA,
  UNSET_USER_COUNTRY_LOCATIONS_DATA,
  SET_ROLE_GROUP_DATA,
  SET_DEPARTMENT_LIST_DATA,
  SET_DEPARTMENT_OPTIONS,
  SET_LOCATIONS_OPTIONS,
  SET_CITY_LIST_DATA,
  SET_CURRENCIES_LIST_DATA,
  SET_CURRENCIES_CONVERSIONS_LIST_DATA,
} from 'src/store/types'
import Vue from 'vue'

export default {
  [SET_MODULE_OPTIONS](state, options) {
    Vue.set(state.modulesOptions, 'data', options)
  },
  [SET_OPERATIONS_DATA](state, options) {
    Vue.set(state.operationsOptions, 'data', options)
  },
  [SET_MODULE_LIST_DATA](state, payload) {
    Vue.set(state.moduleList, 'list', payload.list)
  },
  [SET_ROLE_GROUP_LIST](state, payload) {
    Vue.set(state.roleGroupList, 'list', payload.list)
  },
  [SET_ROLE_GROUP_DATA](state, payload) {
    Vue.set(state.roleGroupData, 'data', payload.data)
  },
  [SET_ROLE_GROUP_LIST_WITH_CHILDS](state, payload) {
    Vue.set(state.allRoleGroupList, 'list', payload.list)
  },
  [SET_MODULE_LIST_DATA_WITH_CHILDS](state, payload) {
    Vue.set(state.allModulesList, 'list', payload.list)
  },
  [SET_ROLES_LIST](state, payload) {
    Vue.set(state.roleList, 'list', payload.list)
  },
  [SET_MASTER_FORM_DATA](state, action) {
    state.formData = action.formData
  },
  [SET_MASTER_OPTIONS](state, options) {
    Vue.set(state.mastersOptions, 'data', options)
  },
  [SET_MASTER_LIST_DATA](state, payload) {
    Vue.set(state.mastersList, 'list', payload.list)
  },
  [SET_MASTER_DATA_OPTIONS](state, options) {
    Vue.set(state.mastersDataOptions, 'data', options)
  },
  [SET_MASTER_DATA_FORM_DATA](state, action) {
    state.formData = action.formData
  },
  [SET_MASTER_DATA_LIST_DATA](state, payload) {
    Vue.set(state.mastersDataList, 'list', payload.list)
  },
  [SET_STAFF_LIST_DATA](state, payload) {
    Vue.set(state.usersList, 'list', payload.list)
  },
  [SET_USER_COUNTRY_LOCATIONS_DATA](state, payload) {
    Vue.set(state.userCountryLocations, 'data', payload.data)
  },
  [UNSET_USER_COUNTRY_LOCATIONS_DATA](state, payload) {
    Vue.set(state.userCountryLocations, 'data', [])
  },
  [SET_STATE_LIST_DATA](state, payload) {
    Vue.set(state.stateList, 'list', payload.list)
  },
  [SET_CITY_LIST_DATA](state, payload) {
    Vue.set(state.cityList, 'list', payload.list)
  },
  [SET_STOCK_LOCATION_LIST_DATA](state, payload) {
    Vue.set(state.stockLocationList, 'list', payload.list)
  },
  [SET_ZONE_LIST_DATA](state, payload) {
    Vue.set(state.zoneList, 'list', payload.list)
  },
  [SET_TAX_LIST_DATA](state, payload) {
    Vue.set(state.taxList, 'list', payload.list)
  },
  [SET_DELIVERY_CHARGE_LIST_DATA](state, payload) {
    Vue.set(state.deliveryChargeList, 'list', payload.list)
  },
  [SET_REPORT_CONFIGS_LIST_DATA](state, payload) {
    Vue.set(state.reportConfigsList, 'list', payload.list)
  },
  [SET_MEMBERSHIP_ROLE_LIST_DATA](state, payload) {
    Vue.set(state.memberShipRoleList, 'list', payload.list)
  },
  [SET_SETTINGS_ENROLLMENT_TYPE](state, payload) {
    Vue.set(state.enrollmentTypeList, 'list', payload)
  },
  [MEMBERSHIP_ROLE_LIST_ROLE_ROW_UPDATE](state, payload) {
    let roleRowIndex = state.memberShipRoleList.list.data.findIndex(x => x.id === payload.id)
    if (roleRowIndex !== -1) {
      state.memberShipRoleList.list.data[roleRowIndex] = { ...payload }
    }
  },
  [SET_DEPARTMENT_LIST_DATA](state, payload) {
    Vue.set(state.departmentList, 'list', payload.list)
  },
  [SET_DEPARTMENT_OPTIONS](state, options) {
    Vue.set(state.departmentOptions, 'data', options)
  },
  [SET_LOCATIONS_OPTIONS](state, options) {
    Vue.set(state.locationsOptions, 'data', options)
  },
  [SET_CURRENCIES_LIST_DATA](state, payload) {
    Vue.set(state.currencyList, 'list', payload.list)
  },
  [SET_CURRENCIES_CONVERSIONS_LIST_DATA](state, payload) {
    Vue.set(state.currencyConversionList, 'list', payload.list)
  },
}
